import {faChevronDown, faChevronUp} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import _ from "../Trans";
import {useEffect, useState} from "react";

export default function Toggle({text, setCollapsedHandler}) {
    const [isCollapsed, setIsCollapsed] = useState(true)
    const translation = _(text)

    const toggle = () => {
        setIsCollapsed(!isCollapsed)
    }

    useEffect(() => {
        setCollapsedHandler(!isCollapsed);
    }, [isCollapsed]); // eslint-disable-line

    return (
        <h6 className="panel-title link" onClick={toggle}>
            <small><FontAwesomeIcon icon={isCollapsed ? faChevronDown : faChevronUp}/></small>
            &nbsp;{translation}&nbsp;
            <small><FontAwesomeIcon icon={isCollapsed ? faChevronDown : faChevronUp}/></small>
        </h6>
    )
}